import curd from '../curd'
import {qs} from '../qs'

const BASE_PATH = '/env/site/factor'

export default curd(BASE_PATH, {
  getConfig: () => ({
    url: `/site/env/config`,
    method: 'GET'
  }),
  saveConfig: data => ({
    url: `/site/config`,
    method: 'PUT',
    data
  }),
  getRealtimeData: () => ({
    url: `/env/data/realtime`,
    method: 'GET'
  }),
  getHistoryData: query => ({
    url: `/env/data/history${qs(query, '?')}`,
    method: 'GET'
  }),
  getEnvFactorCategory: () => ({
    url: `/env/factor/category`,
    method: 'GET'
  }),
  saveEnvFactorCategory: data => ({
    url: `/env/factor/category`,
    method: 'POST',
    data
  }),
  updateEnvFactorCategory: data => ({
    url: `/env/site/factor/updates`,
    method: 'POST',
    data
  })
})



// WEBPACK FOOTER //
// ./src/apis/modules/EnvFactor.js